import React from 'react';
import { subscribe, getInFlightCount } from '@/lib/network-indicator';

const TopProgressBar: React.FC = () => {
  const [count, setCount] = React.useState<number>(() => getInFlightCount());

  React.useEffect(() => {
    const unsub = subscribe((c) => setCount(c));
    return () => unsub();
  }, []);

  if (count <= 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-50">
      <div className="h-0.5 w-full bg-primary/20">
        <div className="h-0.5 bg-primary animate-[loading_1.2s_ease-in-out_infinite]" style={{ width: '40%' }} />
      </div>
      <style>{`
        @keyframes loading {
          0% { transform: translateX(-100%); }
          50% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </div>
  );
};

export default TopProgressBar;


